var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    sourceNode: '',
    sourcePatch: null,
    sourcePort: '',
    edge: '',
    position: null,
};
export var careerSlice = createSlice({
    name: 'career',
    initialState: initialState,
    reducers: {
        setCareerSource: function (state, action) {
            var _a;
            state.sourceNode = action.payload.sourceNode;
            state.sourcePatch = action.payload.sourcePatch;
            state.sourcePort = action.payload.sourcePort;
            state.position = action.payload.position;
            if ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.edge) {
                state.edge = action.payload.edge;
            }
        },
        clearCareerSource: function (state) {
            state.sourceNode = '';
            state.sourcePatch = null;
            state.sourcePort = '';
            state.position = null;
            state.edge = '';
        },
    },
});
export var setCareerSource = (_a = careerSlice.actions, _a.setCareerSource), clearCareerSource = _a.clearCareerSource;
export default careerSlice.reducer;
